import React from 'react'

const CinemaPhoto = () => {
  return (
    <div className='w-full h-full flex items-center justify-center rounded-xl overflow-hidden shadow-md'>
      <img src={"https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/bi-umut-film.jpg"} className='w-full h-full object-cover' />
    </div>
  )
}

export default CinemaPhoto
